/**
 * Fetches the JSON at `path`, bypassing the HTTP cache.
 * Resolves `null` when the fetch fails, the response is not OK or the body is not JSON.
 */
export async function fetchDeployedJson<T>(path: string): Promise<T | null> {
  try {
    const response = await fetch(path, { cache: 'no-store' });
    return response.ok ? await response.json() as T : null;
  } catch {
    return null;
  }
}
